import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

//CSS
import styles from "./excursion.module.less";

export const SpecialExcursion = ({specialExcursionInfo,getTotalPax, setSpecialExcursion}) => {

  const [t] = useTranslation("vtform");
  const [selectedSession, setSelectedSesion] = useState(null);
  let listSessions = null;

  //--------------------------------------------------------------------------------------------------------------------
  function selectSession(session) {
    setSelectedSesion(session);
    setSpecialExcursion(specialExcursionInfo.sessions.sessions[session]);
  }

  if (specialExcursionInfo != null && specialExcursionInfo.hasOwnProperty('sessions')) {
    listSessions = Object.keys(specialExcursionInfo.sessions.sessions).map(session => {
      return (
        <div className={styles.session} key={session}
             className={getTotalPax() <= specialExcursionInfo.sessions.sessions[session]['available'] ? selectedSession == session? styles.sessionselected : styles.session : styles.sessiondisable}
             onClick={()=> getTotalPax() <= specialExcursionInfo.sessions.sessions[session]['available'] ? selectSession(session) : null}
        >
          {specialExcursionInfo.sessions.sessions[session]['session']== "day_wide" ? t('vtspecialexcursion.wideday'): specialExcursionInfo.sessions.sessions[session]['session']}
          {" "}
          [{specialExcursionInfo.sessions.sessions[session]['available']} {t('vtspecialexcursion.freepax')}]
        </div>
      )
    });
  }

  if (listSessions== null) return null;

  return (
    <div className={styles.specialexcursion}>
      <div className={styles.title}>{t('vtspecialexcursion.Seleccione una sesión')}</div>
      <div className={styles.sessions}>
        {listSessions}
      </div>
    </div>
  );

}

export default SpecialExcursion;